// import { useEffect, useState } from 'react'
import classnames from 'classnames/bind'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRef, useEffect } from 'react'

// Components
import Image from '@/components/common/Image'
import handleImageBlur from '@/methods/handleImageBlur'
import { PlaceholderType } from '@/components/common/Image'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ImageListProps {
  spaceBetween: number
  images?: string[]
  activeIndex: number
  onClick: (index: number) => void
}

const ImageList = ({ spaceBetween, images, activeIndex, onClick: handleChangeImage }: ImageListProps) => {
  const swiperRef: any = useRef(null)
  useEffect(() => {
    swiperRef.current.slideTo(activeIndex)
  }, [activeIndex])
  return (
    <div className={cx('image-list')}>
      <Swiper
        initialSlide={activeIndex}
        onInit={(ref) => (swiperRef.current = ref)}
        className={cx('banner__carousell')}
        slidesPerView={'auto'}
        spaceBetween={spaceBetween}
        pagination={{ clickable: true }}
        slideToClickedSlide
        grabCursor
      >
        {images?.map((data: any, index: number) => (
          <SwiperSlide key={index} style={{ width: 'auto' }}>
            <div key={index} className={cx('image-list-image', { active: index === activeIndex })} onClick={() => handleChangeImage(index)}>
              <Image
                alt='image'
                blurDataURL={handleImageBlur()}
                placeholder={PlaceholderType.blur}
                fill
                src={data}
                style={{ objectFit: 'contain' }}
                sizes='(max-width: 500px) 160px,(max-width: 1000px) 320px,(max-width: 1440px) 640px, 320px'
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ImageList
